import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Avatar, CssBaseline, Typography, Container } from "@material-ui/core";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";

// Components
import Footer from "../layout/Footer";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(12),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    marginBottom: theme.spacing(3),
    backgroundColor: theme.palette.primary.light,
  },
}));

const ResetFailed = ({ message }) => {
  const classes = useStyles();

  return (
    <Container component="main" maxWidth="sm">
      <CssBaseline />

      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5" align="center">
          {" "}
          {message}{" "}
        </Typography>{" "}
      </div>

      <Footer />
    </Container>
  );
};

export default ResetFailed;
